import { motion, useReducedMotion } from 'framer-motion';

export const Reveal = ({ children, className = '', delay = 0 }) => {
  const reduced = useReducedMotion();
  return (
    <motion.div className={className} initial={reduced ? false : { opacity: 0.7, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }} transition={{ duration: reduced ? 0 : 0.7, delay: reduced ? 0 : delay, ease: [0.22, 1, 0.36, 1] }}>
      {children}
    </motion.div>
  );
};

export const Chapter = ({ number, label, id }) => (
  <h2 className="start-chapter" id={id} data-testid={`${id}-label`}><span className="start-mono">{number} /</span>{label}</h2>
);